import { useDebouncedCallback } from '../../../hooks/useDebouncedCallback'
import type { InvoicingSettingsSection } from '../enums/invoicingSettingsSection'
import { useTrackInvoicingSettings } from './useTrackInvoicingSettings'

interface UseTrackInvoicingSettingsDebouncedProps {
  section?: InvoicingSettingsSection
}

export const useTrackInvoicingSettingsDebounced = (
  eventDetail: string,
  { section }: UseTrackInvoicingSettingsDebouncedProps = {},
) => {
  const { trackInvoicingSettings } = useTrackInvoicingSettings({ section })

  return useDebouncedCallback(() => trackInvoicingSettings(eventDetail))
}
